class LocalToken {
    Get = () => {
        return JSON.parse(localStorage.getItem('tokenObj'))
    }
    Set = (res) => {
        return localStorage.setItem('tokenObj', JSON.stringify({
            accToken: res.data.AccessToken,
            refToken: res.data.RefreshToken
        }))
    }
    Remove = () => {
        return localStorage.removeItem('tokenObj')
    }
}
export default new LocalToken
